// src/AbonelikEkleFormu.js (Yeni Dosya)
import React, { useState } from 'react';
import { Form, Button, Row, Col, InputGroup } from 'react-bootstrap';

function AbonelikEkleFormu({ kullaniciAdi, onFormSubmit, onIptal }) {
  const [sureDeger, setSureDeger] = useState(1);
  const [sureTipi, setSureTipi] = useState('ay');
  const [ucret, setUcret] = useState('');
  const [paketAdi, setPaketAdi] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit({
      sure_deger: sureDeger,
      sure_tipi: sureTipi,
      ucret: ucret || null,
      paket_adi: paketAdi || null,
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <p><strong>{kullaniciAdi}</strong> için yeni abonelik süresi ekleniyor.</p>
      <hr/>
      <Form.Group as={Row} className="mb-3 align-items-center">
        <Form.Label column sm={3}>Süre Ekle</Form.Label>
        <Col sm={9}>
          <InputGroup>
            <Form.Control 
              type="number" 
              value={sureDeger} 
              onChange={(e) => setSureDeger(e.target.value)} 
              min="1" 
              required 
            />
            <Form.Select value={sureTipi} onChange={(e) => setSureTipi(e.target.value)}>
              <option value="ay">Ay</option>
              <option value="yil">Yıl</option>
            </Form.Select>
          </InputGroup>
        </Col>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Alınan Ücret (TL) (İsteğe Bağlı)</Form.Label>
        <Form.Control type="number" step="0.01" value={ucret} onChange={(e) => setUcret(e.target.value)} placeholder="Örn: 500" />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Paket Adı (İsteğe Bağlı)</Form.Label>
        <Form.Control type="text" value={paketAdi} onChange={(e) => setPaketAdi(e.target.value)} placeholder="Örn: Premium Yıllık Paket" />
      </Form.Group>
      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onIptal} className="me-2">İptal</Button>
        <Button variant="primary" type="submit">Süreyi Ekle</Button>
      </div>
    </Form>
  );
}
export default AbonelikEkleFormu;